import http from './http';

const getDashboard = () => http.get(`/pub/globalStats`);

export default { getDashboard };
export { getDashboard };
